import { Box } from "@chakra-ui/react";
import React from "react";
import { AccountNameInfoProps } from "./AccountNameInfo.types";

const AccountNameInfo: React.FC<AccountNameInfoProps> = ({
  account,
  accountNameProps,
  showManager,
  ...rest
}) => {
  if (!account) return <></>;

  return (
    <Box textStyle={"bodyRegular"} lineHeight={"17px!important"} {...rest}>
      <Box {...accountNameProps}>{account.nameOfRecord}</Box>
      <Box
        textStyle={"bodyXS"}
        color={"text.grey"}
        lineHeight={"17px!important"}
      >
        {showManager && account.manager?.name
          ? `${account.manager.name} - `
          : ""}
        {account.mnumber} - {account.accountType}
      </Box>
    </Box>
  );
};

export default AccountNameInfo;
